/* ============================================================
   REMUSE — theme behaviour
   AJAX cart + drawer, quantity steppers, mobile nav.
   Vanilla JS, no dependencies. Slow/cold motion per the brand.
   ============================================================ */
(function () {
  'use strict';

  var money = function (cents) {
    var fmt = (window.REMUSE && window.REMUSE.moneyFormat) || '${{amount}}';
    var amount = (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, amount);
  };

  /* ---------- Cart drawer open/close ---------- */
  var drawer = document.querySelector('[data-cart-drawer]');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); refreshCart().then(openDrawer); }
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeDrawer(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  /* ---------- Render the drawer contents from a cart object ---------- */
  function renderCart(cart) {
    if (!drawer) return;
    var body = drawer.querySelector('[data-cart-body]');
    var foot = drawer.querySelector('[data-cart-foot]');
    var counts = document.querySelectorAll('[data-cart-count]');

    counts.forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });

    if (!body) return;

    if (cart.item_count === 0) {
      body.innerHTML =
        '<div class="cart-drawer__empty">' +
          '<div class="t-section">The vault is empty</div>' +
          '<p class="t-body">No stones reserved yet.</p>' +
          '<a class="btn btn--outline" href="/collections/all" data-cart-close>Browse stones</a>' +
        '</div>';
      if (foot) foot.hidden = true;
      return;
    }

    if (foot) foot.hidden = false;
    var rows = cart.items.map(function (item) {
      var img = item.image
        ? '<img src="' + item.image.replace(/(\.[^.]+)$/, '_160x$1') + '" alt="' + escapeHtml(item.product_title) + '">'
        : '';
      var optionText = item.options_with_values
        ? item.options_with_values.filter(function (o) { return o.value && o.value !== 'Default Title'; })
            .map(function (o) { return o.value; }).join(' · ')
        : '';
      return '' +
        '<div class="cart-line" data-line-key="' + item.key + '">' +
          '<div class="cart-line__media">' + img + '</div>' +
          '<div>' +
            '<a class="cart-line__name" href="' + item.url + '" data-cart-close>' + escapeHtml(item.product_title) + '</a>' +
            (optionText ? '<div class="cart-line__meta">' + escapeHtml(optionText) + '</div>' : '') +
            '<div class="qty" data-qty>' +
              '<button type="button" data-qty-down aria-label="Decrease">&minus;</button>' +
              '<input type="text" inputmode="numeric" value="' + item.quantity + '" data-qty-input data-line-key="' + item.key + '" aria-label="Quantity">' +
              '<button type="button" data-qty-up aria-label="Increase">+</button>' +
            '</div>' +
          '</div>' +
          '<div>' +
            '<div class="cart-line__price t-price">' + money(item.final_line_price) + '</div>' +
            '<button class="cart-line__remove" type="button" data-line-remove="' + item.key + '">Remove</button>' +
          '</div>' +
        '</div>';
    }).join('');
    body.innerHTML = rows;

    var subtotalEl = drawer.querySelector('[data-cart-subtotal]');
    if (subtotalEl) subtotalEl.textContent = money(cart.total_price);
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- Cart API ---------- */
  function refreshCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; });
  }

  function changeLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; });
  }

  /* ---------- Add to cart (product form) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.dataset.label = btn.textContent; btn.textContent = 'Reserving…'; btn.disabled = true; }
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function () { return refreshCart(); })
      .then(function () { openDrawer(); })
      .catch(function () {})
      .finally(function () {
        if (btn) { btn.textContent = btn.dataset.label || 'Add to vault'; btn.disabled = false; }
      });
  });

  /* ---------- Quantity steppers (PDP + cart lines) ---------- */
  document.addEventListener('click', function (e) {
    var up = e.target.closest('[data-qty-up]');
    var down = e.target.closest('[data-qty-down]');
    if (!up && !down) return;
    var wrap = e.target.closest('[data-qty]');
    var input = wrap && wrap.querySelector('[data-qty-input]');
    if (!input) return;
    var val = parseInt(input.value, 10) || 0;
    val = up ? val + 1 : Math.max(0, val - 1);
    input.value = val;
    commitLineQty(input);
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-qty-input]');
    if (input) commitLineQty(input);
  });

  function commitLineQty(input) {
    var key = input.getAttribute('data-line-key');
    if (!key) return; // PDP qty (not a cart line) — leave as-is for form submit
    changeLine(key, parseInt(input.value, 10) || 0);
  }

  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-line-remove]');
    if (!rm) return;
    changeLine(rm.getAttribute('data-line-remove'), 0);
  });

  /* ---------- Mobile nav ---------- */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-nav-toggle]')) {
      document.body.classList.toggle('nav-open');
    }
  });

  /* ---------- PDP gallery thumbs ---------- */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-thumb]');
    if (!thumb) return;
    var main = document.querySelector('[data-gallery-main]');
    if (main) main.src = thumb.getAttribute('data-full');
    document.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
    thumb.classList.add('is-active');
  });

  /* Initial sync */
  if (drawer) refreshCart();
})();
